#import "../../../../common/graphql/ExtractionTypes.graphql"
query BatchTransactionAvailableDocumentTypes {
  batchTransactionAvailableDocumentTypes {
    nodes {
      id
      documentType
      isAccountingDocument
      ...ExtractionTypes
    }
  }
}
